import { BaseMarkerHandles } from '../base/baseMarkerHandles'
import { SquareHandle } from '../handles/squareHandle'
import { PolygonMarker } from './polygonMarker'
import type { Point } from '../../types'

export class PolygonMarkerHandles extends BaseMarkerHandles<PolygonMarker, SquareHandle> {
  handlePositions: Array<Point> = []

  //TODO Remove once all marker types have been updated to no longer relying
  //on storing values for handle positions
  populateHandlePositions(): void {
    throw new Error('Method not implemented.')
  }

  getPressedHandleIndex(): number {
    return this.marker.state.handles.findIndex((handle) => handle === this.marker.state.pressedHandle)
  }

  getMousedOverHandle(): SquareHandle | undefined {
    const handles = this.marker.state.handles
    let mousedOverHandle = undefined
    handles.some((handle: SquareHandle) => {
      if (handle.isMousedOver()) {
        mousedOverHandle = handle
        return true
      }
      return false
    })
    return mousedOverHandle
  }

  syncVertexHandles(): void {
    const state = this.marker.state
    state.vertices.forEach((vertex) => {
      if (vertex.handle) {
        vertex.handle.position = {
          x: vertex.x,
          y: vertex.y,
        }
      }
    })
  }

  populate(): void {
    const state = this.marker.state
    this.marker.state.handles = state.vertices.map((vertex) => {
      const handle = new SquareHandle(
        this.marker.p,
        { x: vertex.x, y: vertex.y },
        this.marker.state.handleRadius,
        this.marker.state.handleStrokeWeight
      )
      vertex.handle = handle
      return handle
    })
  }
}
